export const environment = {
  production: true,
  env: 'Production',
  ApiUrl: 'https://h2hapi.clavisco.com/',  //revisar URL
  SentryDsn: 'https://70e9d40adaaa1a0256adb3587bfa4cd5@o4511328163725312.ingest.us.sentry.io/4512218642448384'
};
